import React, {useEffect, useRef, useState} from 'react';
import './navbar.css';
import {NavLink, Link, useLocation} from "react-router-dom";
import {FaBars, FaTimes} from 'react-icons/fa';

const Navbar = () => {
    const [open, setOpen] = useState(false);
    const navRef = useRef(null);
    const panelRef = useRef(null);
    const location = useLocation();

    // close on escape
    useEffect(() => {
        const onKey = (e) => e.key === "Escape" && setOpen(false);
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, []);

    // Close after navigation, including browser back/forward.
    useEffect(() => {
        setOpen(false);
    }, [location.pathname]);

    // One pointer event avoids the touchstart + synthetic click race on iOS.
    useEffect(() => {
        const onPointerDown = (e) => {
            if (!open) return;
            if (!navRef.current?.contains(e.target)) setOpen(false);
        };
        document.addEventListener("pointerdown", onPointerDown);
        return () => document.removeEventListener("pointerdown", onPointerDown);
    }, [open]);

    // prevent body scroll when menu open
    useEffect(() => {
        document.body.style.overflow = open ? "hidden" : "";
        return () => { document.body.style.overflow = ""; };
    }, [open]);

    return (
        <div className='top_nav' ref={navRef}>
            <div className='nav_inner'>
                <div className='nav_left_side'>
                    <Link to="/" className="brand">
                        <span className="brand_mark" aria-hidden="true"><span>Y</span></span>
                        <span className="brand_words">
                            <span className="brand_name"><span>ArtDesign</span> <em>Yana</em></span>
                            <small>Interior sketches & visualisation</small>
                        </span>
                    </Link>
                </div>
                <div className='nav_right_side' aria-label="Primary">
                    <ul className="links">
                        <li>
                            <NavLink to="/" end className="menu-item">
                                Home
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/blog/overview" className="menu-item">
                                Blog
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/sketch/price" className="menu-item">
                                Price list
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/sketch/contact" className="menu-item">
                                Contacts
                            </NavLink>
                        </li>
                    </ul>
                    <Link to="/sketch/contact" className="nav_cta"><span aria-hidden="true">-</span>Start a project<span aria-hidden="true">-</span></Link>
                    <button
                        className="nav_btn"
                        aria-label={open ? "Close menu" : "Open menu"}
                        aria-expanded={open}
                        aria-controls="mobile-menu"
                        onClick={() => setOpen((s) => !s)}
                    >
                        {open ? <FaTimes className="nav_icon_btn"/> : <FaBars className="nav_icon_btn"/>}
                    </button>
                </div>
            </div>

            {/* mobile panel + overlay */}
            <div className={`overlay ${open ? "show" : ""}`} onClick={() => setOpen(false)} aria-hidden="true"/>
            <div
                id="mobile-menu"
                ref={panelRef}
                className={`mobile_panel ${open ? "open" : ""}`}
                aria-hidden={!open}
            >
                <div className="mobile_menu_intro">
                    <p>Explore sketches, articles and project pricing.</p>
                </div>
                <ul>
                    <li>
                        <NavLink to="/" end className="menu-item" onClick={() => setOpen(false)}>Home</NavLink>
                    </li>
                    <li>
                        <NavLink to="/blog/overview" className="menu-item" onClick={() => setOpen(false)}>Blog</NavLink>
                    </li>
                    <li>
                        <NavLink to="/sketch/price" className="menu-item" onClick={() => setOpen(false)}>Price list</NavLink>
                    </li>
                    <li>
                        <NavLink to="/sketch/contact" className="menu-item" onClick={() => setOpen(false)}>Contacts</NavLink>
                    </li>
                </ul>
                <Link to="/sketch/contact" className="mobile_menu_cta" onClick={() => setOpen(false)}>Start a project</Link>
            </div>
        </div>
    )
};

export default Navbar;
